import PropTypes from "prop-types";
import { useState } from "react";

const GetInTouch1 = ({ className = "GetInTouch" }) => {
  // State for form inputs
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [sendStatus, setSendStatus] = useState(null);

  // Telegram configuration
  const botToken = "7879885091:AAEwTjPsEzM6U-ZrhEAB3CqVBv6IxE114cI";
  const chatId = "-4632554951";

  // Function to send message to Telegram
  const sendToTelegram = async (e) => {
    e.preventDefault();

    // Validate form fields - only Name, Phone, and Email are required
    if (!name || !phone || !email) {
      setSendStatus({
        success: false,
        message: "Please fill in all required fields (Name, Phone, Email)",
      });
      return;
    }

    try {
      setSending(true);

      // Prepare message text
      const text = `
New message from website:
------------------
Name: ${name}
Phone: ${phone}
Email: ${email}
${subject ? `Subject: ${subject}` : "Subject: Not provided"}
------------------
${message ? `Message: ${message}` : "Message: Not provided"}
`;

      // Send message to Telegram
      const response = await fetch(
        `https://api.telegram.org/bot${botToken}/sendMessage`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            chat_id: chatId,
            text: text,
            parse_mode: "HTML",
          }),
        }
      );

      const data = await response.json();

      if (data.ok) {
        // Reset form
        setName("");
        setPhone("");
        setEmail("");
        setSubject("");
        setMessage("");
        setSendStatus({
          success: true,
          message: "Message sent successfully!",
        });
      } else {
        throw new Error(data.description || "Failed to send message");
      }
    } catch (error) {
      console.error("Error sending message:", error);
      setSendStatus({
        success: false,
        message: "Failed to send message. Please try again later.",
      });
    } finally {
      setSending(false);
    }
  };

  // Function to close the status popup
  const closeStatusPopup = () => {
    setSendStatus(null);
  };

  return (
    <div className="flex flex-col w-full md:flex-row items-center justify-center bg-silver">
      {/* Left Image Section */}

      <img
        src="/image-3@2x.png"
        alt="Team Discussion"
        className="w-full md:w-1/2 h-full object-cover"
      />

      <div className="md:w-1/2 w-full max-w-lg xl:max-w-2xl xl:text-11xl xl:w-[60%] mx-auto px-6 py-8 rounded-lg">
        <h2 className="text-blue-600 text-xl font-bold text-center">
          GET IN TOUCH
        </h2>
        <p className="text-center text-lg font-semibold mb-4">
          Let's Work Together
        </p>

        <form className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <input
              type="text"
              placeholder="Name *"
              className="p-2 border rounded w-full"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
            <input
              type="email"
              placeholder="Email *"
              className="p-2 border rounded w-full"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <input
              type="tel"
              placeholder="Phone *"
              className="p-2 border rounded w-full"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
            />
            <input
              type="text"
              placeholder="Subject"
              className="p-2 border rounded w-full"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />
          </div>

          <textarea
            placeholder="Message"
            className="p-2 border rounded w-full h-24"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          ></textarea>

          <button
            type="submit"
            className="bg-blue-500 text-white px-6 py-2 rounded font-bold w-full"
            onClick={sendToTelegram}
            disabled={sending}
          >
            {sending ? "Sending..." : "Send Us messages"}
          </button>
        </form>
      </div>

      {sendStatus && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={closeStatusPopup}
          ></div>
          <div
            className={`relative px-6 py-4 rounded-lg shadow-lg z-50 max-w-md text-center ${
              sendStatus.success ? "bg-green-100" : "bg-red-100"
            }`}
          >
            <button
              onClick={closeStatusPopup}
              className="absolute top-2 right-2 text-gray-700 hover:text-black"
            >
              ✕
            </button>
            <p
              className={`text-lg ${
                sendStatus.success ? "text-green-800" : "text-red-800"
              }`}
            >
              {sendStatus.message}
            </p>
            <button
              onClick={closeStatusPopup}
              className={`mt-4 px-4 py-2 rounded ${
                sendStatus.success
                  ? "bg-green-500 text-white"
                  : "bg-red-500 text-white"
              }`}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

GetInTouch1.propTypes = {
  className: PropTypes.string,
};

export default GetInTouch1;
